import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {ConfigService} from "../../services/config.service";
import { CommonService } from '@rubii/frontend-common';
import { ItemResponse } from '@rubii/frontend-common/lib/models/common/Response';
import { Shared } from '@rubii/frontend-common';
import { BaseComponent } from '@rubii/frontend-common';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ClientService } from '../../services/client.service';


@Component({
  selector: 'app-forget',
  templateUrl: './forget.component.html',
  styleUrls: ['./forget.component.scss']
})
export class ForgetComponent extends BaseComponent implements OnInit {

  emailFormControl: FormControl;

  sent = false;

  constructor(private config: ConfigService, private client: ClientService, private snackBar: MatSnackBar) {
      super();
      this.emailFormControl = new FormControl('', [
          Validators.required,
          Validators.email,
      ]);
  }

  ngOnInit() {
  }

  sendEmail() {
      if (this.emailFormControl.valid) {
          let email = this.emailFormControl.value;
          let input = {email: email};
          this.client.user.forgetPassword(input).then(res => this.forgetPassCallback({result: true, data: res} as ItemResponse)).catch(e => this.forgetPassCallback({result: false, text: e.message} as ItemResponse));
      }
  }

  forgetPassCallback(response: ItemResponse) {
      Shared.helpers.LogHelper.debug(response);
      if (response.result) {
          this.sent = true;
      } else {
          this.openSnackBarWarning(this.snackBar, response.text);
      }
  }

}
